import React, { useMemo, useState } from 'react'
import { motion } from 'motion/react'

import { EffectBackgroundProps } from '../types'

export const BoxesEffect = React.memo(({ layerStyle, index, values }: EffectBackgroundProps) => {
  const effectColors = useMemo(() => values.effectColors || ['#6366f1', '#8b5cf6', '#ec4899'], [values.effectColors])
  const effectSpeed = values.effectSpeed ?? 100
  const effectOpacity = values.effectOpacity ?? 100
  const effectBackgroundColor = values.effectBackgroundColor || '#000000'
  const opacityValue = effectOpacity / 100

  const rows = 5
  const cols = 8
  const boxes = Array.from({ length: rows * cols }, (_, i) => i)

  const [hoveredBox, setHoveredBox] = useState<number | null>(null)

  return (
    <div
      style={{
        position: 'absolute' as const,
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: -index - 1,
        backgroundColor: effectBackgroundColor,
      }}
    >
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: `repeat(${cols}, 1fr)`,
          gridTemplateRows: `repeat(${rows}, 1fr)`,
          width: '100%',
          height: '100%',
          gap: 4,
          padding: 8,
        }}
      >
        {boxes.map((boxIndex) => (
          <motion.div
            key={boxIndex}
            style={{
              backgroundColor: effectColors[boxIndex % effectColors.length],
              borderRadius: '8px',
              cursor: 'pointer',
            }}
            initial={{ opacity: 0.3 * opacityValue }}
            whileHover={{
              opacity: opacityValue,
              scale: 1.1,
            }}
            animate={{
              opacity: hoveredBox === boxIndex ? opacityValue : 0.3 * opacityValue,
            }}
            transition={{
              duration: 0.3 * (100 / Math.max(effectSpeed, 1)),
            }}
            onHoverStart={() => setHoveredBox(boxIndex)}
            onHoverEnd={() => setHoveredBox(null)}
          />
        ))}
      </div>
    </div>
  )
})
BoxesEffect.displayName = 'BoxesEffect'
